import { css } from 'linaria';
import { styled } from 'linaria/react';

export const articleContainer = css`
  width: 100%;
  margin-bottom: var(--space-150);
  color: var(--text-minor);
  letter-spacing: 2px !important;
  height: var(--space-200);
  &::after {
    content: '';
    display: block;
  }
`;
export const displayedNameContainer = css`
  color: var(--text-primary);
  word-break: break-word;
`;
export const copyIconClass = css`
  cursor: pointer;
  svg {
    top: 75%;
    left: 25%;
  }
`;

export const MarkerLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-100);
  padding-bottom: var(--space-150);
`;
